import Dialog from "dialog";
import template from "./dialog-config.html";
import css from "./dialog-config.css";

class ConfigCO2Dialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-co2", ConfigCO2Dialog);
  }
  constructor() {
    super();

    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

    this.onupdatedevices_handler({detail: application.devices});

    this.show();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.mx200co2.id;
    this.textboxDeviceStatus.value = devices.mx200co2.status;
    this.textboxValue.value = devices.mx200co2.value;
    this.textboxInternalTemperature.value = devices.mx200co2.internalTemperature;
    this.textboxInternalBarometricPressure.value = devices.mx200co2.internalBarometricPressure;
    this.textboxOnBoardTemperature.value = devices.mx200co2.onBoardTemperature;
    this.textboxOnBoardBarometricPressure.value = devices.mx200co2.onBoardBarometricPressure;
    this.textboxOnBoardRelativeHumidity.value = devices.mx200co2.onBoardRelativeHumidity;

  }
  buttonClose_click(event) {
    this.close();
  }
  async buttonCalibrateZero_click(event) {
    try {
      this.buttonCalibrateZero.icon.iconname = "view-refresh";
      await server.rcall("RM_mx200co2_calibratezero");
      this.buttonCalibrateZero.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateZero.icon.iconname = "process-stop";
    }
  }
  async buttonCalibrateSpan_click(event) {
    try {
      this.buttonCalibrateSpan.icon.iconname = "view-refresh";
      await server.rcall("RM_mx200co2_calibratespan", parseInt(this.textboxCalibrateSpan.value));
      this.buttonCalibrateSpan.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateSpan.icon.iconname = "process-stop";
    }
  }
  close() {
    super.close();
  }
}

ConfigCO2Dialog.constructor();

export default ConfigCO2Dialog;